import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function AdminShell({ title, children }) {
  const navigate = useNavigate();
  const { logout } = useAuth();
  return (
    <div className="min-h-screen bg-[#F4F6F4]">
      <div className="sticky top-0 z-20 border-b border-slate-200 bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-5 py-4">
          <div className="flex items-center gap-3">
            <Link to="/mind" data-testid="back-to-admin" className="inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-3 py-1.5 text-sm font-semibold text-slate-700 transition hover:bg-slate-200">
              <ArrowLeft className="h-4 w-4" /> Voltar ao Admin
            </Link>
            <h1 className="font-display text-lg font-bold tracking-tight text-slate-900">{title}</h1>
          </div>
          <Button variant="outline" size="sm" onClick={() => { navigate("/login"); logout(); }} data-testid="admin-shell-logout" className="rounded-full border-slate-200 text-slate-600">
            <LogOut className="mr-1.5 h-4 w-4" /> Sair
          </Button>
        </div>
      </div>
      <div className="mx-auto max-w-5xl px-5 py-6">{children}</div>
    </div>
  );
}
